// src/theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({

    components: {
        Button: {
            defaultProps: {
            variant: "unstyled",
            },
        },
        },

    fonts: {
    heading: "Mona sans, sans-serif",
    body: "Mona sans, sans-serif",
  },
});

export default theme;
